import { Box, Stack } from "@mui/material";
import QuickActions from "../../interface/shared/quickactions";
import NavigationHeader from "../../interface/shared/navigation";
import { Outlet } from "react-router";
import { PageTransition } from "../../interface/shared/animations";

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
    return (
        <Box sx={{ px: { xs: 2, md: 4 }, py: 2, minWidth: '1024px' }}>
            <Stack spacing={2}>
                <NavigationHeader />
                <PageTransition>{children}</PageTransition>
            </Stack>
        </Box>
    );
}